import Seo from "../components/Seo";

export default function usePageMeta({ title, description, path, noindex = false, jsonLd }) {
  return (
    <Seo
      title={title}
      description={description}
      path={path}
      noindex={noindex}
      robots={noindex ? "noindex, nofollow" : undefined}
      jsonLd={jsonLd}
    />
  );
}
